import { Close } from '@mui/icons-material'
import { Modal, Card, CardHeader, IconButton, CardContent, Grid, CardActions, Box, Typography, Button } from '@mui/material'
import React, { Dispatch, SetStateAction } from 'react'
import { IApplicationAnswer } from '../../../Types/Application';
import { useKaziNavigate } from '../../../Hooks/useKaziNavigate';

interface ITalentViewApplicationModalProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    applicationInfo: {
        client_locator: string;
        client_name: string;
        client_avatar: React.ReactNode;
        job_locator: string;
        job_title: string;
        job_type: string;
        questions: {id: number, question: string}[];
        form?: IApplicationAnswer[];
    };
}

export const TalentViewApplicationModal = ({open, setOpen, applicationInfo}: ITalentViewApplicationModalProps) => {
    /* ******************** Hooks ******************** */
    const { navigateWithBack } = useKaziNavigate();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClose = () =>{
        setOpen(false);
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    if (!applicationInfo)
        return null
    return (
        <Modal
            open={open}
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <Card
                sx={{
                    width: "600px",
                    borderRadius: "12px",
                    maxHeight: "95%"
                }}
            >
                <CardHeader 
                    sx={{
                        paddingBottom: 1
                    }}                
                    action={
                        <IconButton onClick={handleClose}>
                            <Close color='primary'/>
                        </IconButton>
                    }
                />
                <CardContent
                    sx={{
                        padding: '0 24px'
                    }}
                >                    
                    <Grid container gap={'20px'} flexDirection={'column'}>
                        <Grid  flex={1} display={'flex'} flexDirection={'row'} gap={2}>
                            <Grid display={'flex'} flexDirection={'column'} justifyContent={'center'}> 
                                {applicationInfo.client_avatar}
                            </Grid>
                            <Grid  display={'flex'} flexDirection={'column'}>
                                <Typography variant='lora-title-large' fontWeight={'bold'}>{applicationInfo.client_name}</Typography>
                                <Typography variant='body-smaller' >{applicationInfo.job_title} · {applicationInfo.job_type}</Typography>
                            </Grid>
                        </Grid>
                        {
                            applicationInfo.form && applicationInfo.form.map((q) => (
                            <Grid  key={q.question_id} flex={1} display={'flex'} flexDirection={'column'} gap={2}>
                                <Typography variant='body-small' sx={{color: 'black.200'}}>{applicationInfo?.questions?.find( j => j.id == q.question_id)?.question}</Typography>
                                <Typography variant='body-medium' >{q.answer}</Typography>
                            </Grid>
                        ))
                        }
                    </Grid>
                </CardContent>
                <CardActions
                    sx={{
                        padding: '24px'
                    }}
                >
                    <Box display={'flex'} flexDirection={'row'} width={'100%'}>
                        {
                            // isUploading || talentUpdateResponseLoading ?
                            // null :
                            <>
                                <Box flex={2} display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} gap={1}>
                                    <Button variant='text' onClick={() => navigateWithBack(`/marketplace/posting/${applicationInfo.job_locator}`)}>View job post</Button>
                                    <Button variant='contained' onClick={handleClose}>Close</Button>
                                </Box>
                            </>
                        }
                    </Box>
                </CardActions>
            </Card> 
        </Modal>
    )
}